import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import "./OurCourses.css";

const COURSES = [
  {
    slug: "english-for-adults",
    title: "English for Adults",
    description:
      "A comprehensive English language program designed to help adults improve communication skills for professional and everyday use.",
    cover: "/English-Cover.png",
    path: "/courses/english-for-adults",
  },
  {
    slug: "toefl",
    title: "TOEFL Preparation",
    description:
      "Intensive preparation for the Test of English as a Foreign Language with expert strategies to maximize your score.",
    cover: "/TOEFL-Cover.png",
    path: "/courses/toefl",
  },
  {
    slug: "ielts",
    title: "IELTS Preparation",
    description:
      "Expert-guided IELTS preparation covering all four core skills: reading, writing, listening, and speaking.",
    cover: "/IELTS-Cover.png",
    path: "/courses/ielts",
  },
  {
    slug: "microsoft-programs",
    title: "Microsoft Programs",
    description:
      "Professional Microsoft Office and digital skills certification programs to enhance your productivity and career prospects.",
    cover: "/Microsoft-programs-Cover.png",
    path: "/courses/microsoft-programs",
  },
];

function OurCourses() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: "mobile",
      throttleDelay: 99,
      debounceDelay: 50,
    });
  }, []);

  return (
    <section className="our-courses-section" id="our-courses">
      <Helmet>
        <meta
          name="description"
          content="Explore Talent Track's language and professional courses: English for Adults, TOEFL, IELTS, and Microsoft Programs."
        />
      </Helmet>
      <Container>
        <div className="our-courses-header text-center">
          <h2 className="our-courses-title">Our Courses</h2>
          <p className="our-courses-subtitle">
            Enhance your skills with our professionally designed programs
          </p>
        </div>

        <Row className="justify-content-center g-4">
          {COURSES.map((course, index) => {
            const Icon = course.Icon;
            return (
              <Col
                key={course.slug}
                xs={12}
                sm={6}
                lg={3}
                className="d-flex justify-content-center"
                data-aos="fade-up"
                data-aos-delay={index * 120}
              >
                <Card className="oc-card border-0">
                  <div className="oc-card-image-area">
                    <img
                      src={course.cover}
                      alt={course.title}
                      className="oc-card-cover-img"
                    />
                  </div>
                  <Card.Body className="oc-card-body d-flex flex-column">
                    <Card.Title className="oc-card-title">
                      {course.title}
                    </Card.Title>
                    <Card.Text className="oc-card-desc flex-grow-1">
                      {course.description}
                    </Card.Text>
                    <Button
                      className="oc-view-btn w-100 mt-3"
                      onClick={() => navigate(course.path)}
                    >
                      View Details
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default OurCourses;
